import { Injectable } from '@angular/core';
import { Adapter } from '../adapter.service';
import { RiwayatPendidikan } from '../../../models/pegawai/riwayat-pendidikan.model';

@Injectable({
  providedIn: 'root',
})
export class RiwayatPendidikanAdapter implements Adapter<RiwayatPendidikan> {
  adapt(item: any): RiwayatPendidikan {
    return {
      id: item.idRiwayatPendidikan,
      idKaryawan: item.idKaryawan,
      idPendidikan: item.idPendidikan,
      namaSekolah: item.namaSekolah,
      tahunIjazah: item.tahunIjazah,
      dateMake: item.dateMake,
      url: item.url,
      bidangStudi: item.bidangStudi,
      negara: item.negara || item.Negara,
      tahunMulaiStudi: item.tahunMulaiStudi,
      idDataKlinik: item.idDataKlinik,
      pendidikan: item.pendidikan,
      namaKaryawan: item.namaKaryawan,
      statusAktif: item.statusAktif,
      catatan: item.catatan,
    };
  }
}
